import React, { useEffect, useRef, useState } from "react";
import { RecIcon } from "../materials/MaterialRecordParts";
import "../materials/materialRecord.css";
import "./timeLogs.css";

/** ⋮ menu for the record top bar (secondary / destructive actions). */
export function BarMenu({ items }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (event.type === "keydown") {
        if (event.key === "Escape") setOpen(false);
        return;
      }
      if (!ref.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("pointerdown", close);
      document.removeEventListener("keydown", close);
    };
  }, [open]);
  if (!items.length) return null;
  return (
    <div className="tl-barmenu" ref={ref}>
      <button
        type="button"
        className="rec-bar__btn"
        aria-label="More actions"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <RecIcon name="more" />
      </button>
      {open ? (
        <div className="mat-menu tl-barmenu__menu" role="menu">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              role="menuitem"
              className={`mat-menu__item${item.danger ? " tl-menu-danger" : ""}`}
              onClick={() => {
                setOpen(false);
                item.onSelect();
              }}
            >
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

